import { createIntl, createIntlCache } from "react-intl";

import componentLangEn from "./en/component.en.json";
import dashboardLangEn from "./en/dashboard.en.json";
import questionnaireLangEn from "./en/questionnaire.en.json";
import componentLangEs from "./es/component.es.json";
import dashboardLangEs from "./es/dashboard.es.json";
import questionnaireLangEs from "./es/questionnaire.es.json";

export const TRANSLATIONS_FOR_USERS_LOCALE = {
  en: {
    ...componentLangEn,
    ...dashboardLangEn,
    ...questionnaireLangEn,
  },
  es: {
    ...componentLangEs,
    ...dashboardLangEs,
    ...questionnaireLangEs,
  },
};

export type LanguageKeys = keyof (typeof TRANSLATIONS_FOR_USERS_LOCALE)["en"];

declare global {
  namespace FormatjsIntl {
    interface Message {
      ids: LanguageKeys;
    }
  }
}

const cache = createIntlCache();

export type LanguageParam = "en" | "es";

export const createIntlModule = (locale: LanguageParam) => {
  return createIntl(
    {
      locale,
      messages: TRANSLATIONS_FOR_USERS_LOCALE[locale],
      defaultLocale: "en",
    },
    cache
  );
};
